// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IEoyPlanReconciliationPlanDto } from './IEoyPlanReconciliationPlanDto';
import {
    IEoyPlanReconciliationPlanDtoFromJSON,
    IEoyPlanReconciliationPlanDtoFromJSONTyped,
    IEoyPlanReconciliationPlanDtoToJSON,
    IEoyPlanReconciliationPlanDtoToJSONTyped,
} from './IEoyPlanReconciliationPlanDto';

/**
 * 
 * @export
 * @interface IEoyPlanReconciliationResponseDto
 */
export interface IEoyPlanReconciliationResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IEoyPlanReconciliationResponseDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IEoyPlanReconciliationResponseDto
     */
    plan_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IEoyPlanReconciliationResponseDto
     */
    trigger_plan_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IEoyPlanReconciliationResponseDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IEoyPlanReconciliationResponseDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IEoyPlanReconciliationResponseDto
     */
    plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEoyPlanReconciliationResponseDto
     */
    status?: IEoyPlanReconciliationResponseDtoStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IEoyPlanReconciliationResponseDto
     */
    plan_termination_finish_required?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IEoyPlanReconciliationResponseDto
     */
    triggered_by?: IEoyPlanReconciliationResponseDtoTriggeredByEnum;
    /**
     * 
     * @type {Array<IEoyPlanReconciliationPlanDto>}
     * @memberof IEoyPlanReconciliationResponseDto
     */
    plans?: Array<IEoyPlanReconciliationPlanDto>;
}

/**
* @export
* @enum {string}
*/
export enum IEoyPlanReconciliationResponseDtoStatusEnum {
    STARTED = 'STARTED',
    COMPLETED = 'COMPLETED',
    APPROVED = 'APPROVED',
    VOIDED = 'VOIDED',
    WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL'
}
/**
* @export
* @enum {string}
*/
export enum IEoyPlanReconciliationResponseDtoTriggeredByEnum {
    DAILY_SCHEDULE = 'DAILY_SCHEDULE',
    PLAN_FORFEITURE = 'PLAN_FORFEITURE',
    POLICY_FORFEITURE = 'POLICY_FORFEITURE',
    PLAN_TERMINATION = 'PLAN_TERMINATION',
    AD_HOC = 'AD_HOC',
    MONTHLY_REPROCESSING = 'MONTHLY_REPROCESSING'
}


/**
 * Check if a given object implements the IEoyPlanReconciliationResponseDto interface.
 */
export function instanceOfIEoyPlanReconciliationResponseDto(value: object): value is IEoyPlanReconciliationResponseDto {
    return true;
}

export function IEoyPlanReconciliationResponseDtoFromJSON(json: any): IEoyPlanReconciliationResponseDto {
    return IEoyPlanReconciliationResponseDtoFromJSONTyped(json, false);
}

export function IEoyPlanReconciliationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEoyPlanReconciliationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'trigger_plan_id': json['trigger_plan_id'] == null ? undefined : json['trigger_plan_id'],
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'status': json['status'] == null ? undefined : json['status'],
        'plan_termination_finish_required': json['plan_termination_finish_required'] == null ? undefined : json['plan_termination_finish_required'],
        'triggered_by': json['triggered_by'] == null ? undefined : json['triggered_by'],
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(IEoyPlanReconciliationPlanDtoFromJSON)),
    };
}

export function IEoyPlanReconciliationResponseDtoToJSON(json: any): IEoyPlanReconciliationResponseDto {
    return IEoyPlanReconciliationResponseDtoToJSONTyped(json, false);
}

export function IEoyPlanReconciliationResponseDtoToJSONTyped(value?: IEoyPlanReconciliationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'plan_id': value['plan_id'],
        'trigger_plan_id': value['trigger_plan_id'],
        'invoice_id': value['invoice_id'],
        'amount': value['amount'],
        'plan_name': value['plan_name'],
        'status': value['status'],
        'plan_termination_finish_required': value['plan_termination_finish_required'],
        'triggered_by': value['triggered_by'],
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(IEoyPlanReconciliationPlanDtoToJSON)),
    };
}

